import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import {
  ActionModalSchema,
  Context,
  TransitionOptions,
  Transitions
} from "../../types"

export const saveCancelModalState = <T = any>(
  returnTarget: string,
  serviceCall: string,
  options?: TransitionOptions<T>
): StateNodeConfig<
  Context,
  ActionModalSchema,
  Transitions,
  BaseActionObject
> => {
  const {
    loadingState,
    onSuccess,
    onError,
    successActions = [],
    errorActions = [],
    cancelActions = [],
    cancelTarget
  } = options

  return {
    initial: "idle",
    states: {
      idle: {
        on: {
          SAVE: {
            target: "transition",
            actions: assign((_ctx, { snackbarMessageInfo }) => ({
              snackbarMessageInfo
            }))
          },
          CANCEL: {
            target: cancelTarget ?? returnTarget,
            actions: cancelActions
          }
        }
      },
      transition: {
        entry: assign<Context>(ctx => ({
          loading: loadingState
            ? { ...ctx.loading, [loadingState]: true }
            : ctx.loading
        })),
        exit: assign<Context>(ctx => ({
          loading: loadingState
            ? { ...ctx.loading, [loadingState]: false }
            : ctx.loading
        })),
        invoke: {
          id: "transition",
          src: serviceCall,
          onDone: {
            target: returnTarget,
            actions: [
              onSuccess && assign<Context, DoneInvokeEvent<T>>(onSuccess),
              ...successActions
            ]
          },
          onError: {
            target: returnTarget,
            actions: [
              onError && assign<Context, DoneInvokeEvent<any>>(onError),
              ...errorActions
            ]
          }
        }
      }
    }
  }
}
